export const TAGS = {
  CAMPAIGNS: 'campaigns',
  CAMPAIGN: 'campaign',
  CLIENTS: 'clients',
  CLIENT: 'client',
  DISPOSITIONS: 'dispositions',
  PROSPECTS: 'prospects',
  USERS: 'users',
  IMPORTS: 'imports',
  IMPORT: 'import',
  IMPORT_RECORDS: 'importRecords',
  FIELDS: 'fields',
  FIELDS_ENTITY: 'entityFields',
  VIEWS: 'views',
}

export const TAGS_ARRAY = Object.values(TAGS)
